import PropTypes from "prop-types";
import styles from "./styles";
import global from "../../styles";
import classNames from "classnames";
import { replaceJSX } from "../../utilities/replaceJSX";
import { useLocaleProvider, useTranslate } from "../../context/locale-provider";

const TsAndCs = ({ termsText, privacyPolicyText }) => {
  const { languageStrings, localisedLinks } = useLocaleProvider();
  const translate = useTranslate({ languageStrings });
  const links = replaceJSX(
    translate("loyalty_landing_page_intro_hyperlinks"),
    "%{termslink}",
    <a
      target="_blank"
      rel="noreferrer"
      href={`${localisedLinks.termsAndConditions}?ctaref=${encodeURIComponent(
        "TsandCs ~ invited landing page"
      )}`}
    >
      {termsText}
    </a>
  ).map((translationString) => {
    if (typeof translationString === "string") {
      return replaceJSX(
        translationString,
        "%{privacypolicylink}",
        <a target="_blank" rel="noreferrer" href={localisedLinks.privacyPolicy}>
          {privacyPolicyText}
        </a>
      );
    } else {
      return translationString;
    }
  });

  return (
    <div className={classNames(styles.tsAndCsLink, global.leavesden3)}>
      {links}
    </div>
  );
};

TsAndCs.propTypes = {
  termsText: PropTypes.string,
  privacyPolicyText: PropTypes.string,
};

export default TsAndCs;
